module.exports = __webpack_public_path__ + "static/media/CONA P.25257ebf.jpeg";